import Dungeon, { DungeonConfig } from "./dungeon";
import Point from "./point";
import Room from "./room";
import TILES, { DebugTileMap } from "./tiles";
import { DebugHtmlConfig, DebugConsoleConfig } from "./debug";

export default Dungeon;
export { DungeonConfig, Point, Room, TILES, DebugTileMap, DebugHtmlConfig, DebugConsoleConfig };
